<template>
  <div class="videoGroup-con">
    <div
      class="vG-item clearfix"
      v-for="item in CoursewareList"
      :key="item.index"
    >
      <div @click="tovideolist(item.id)">
        <img
          :src="item.coverphoto"
          alt=""
          class="fl"
          :onerror="defaultImg"
        >
        <p class="fl">{{item.filename}}</p>
      </div>
    </div>
    <div
      v-show="isHasdata"
      class="noData"
    >
      <img
        src="../assets/imgs/noDataIcon.png"
        alt=""
      >
      <p class="noDataTit">未查询到相关数据</p>
      <p>暂无数据，请刷新重试</p>
    </div>
  </div>
</template>

<script>
import { Indicator } from 'mint-ui'
import { getCoursewareFolder } from '../../src/api/Api'
export default {
  name: 'vListsCon',
  data () {
    return {
      isHasdata: false, // 有无数据
      StudyMonth: '', // 当前学年
      userId: sessionStorage.getItem('userId'),
      CompanyId: sessionStorage.getItem('companyId'),
      ProfessionId: sessionStorage.getItem('professionId'),
      CoursewareList: [], // 课程列表
      defaultImg: 'this.src="' + require('../assets/imgs/banner.png') + '"', // 默认图地址
      path: window.baseapi.baseUrl,
      hyCode:0,
    }
  },
  created () {
    this.StudyMonth = this.$route.query.year
    this.hyCode = this.$route.query.hyCode
    this.getCoursewareFolder()
  },
  mounted () {
    window.myVue = this
  },
  sdestroyed () {
    Indicator.close()
  },
  methods: {
    getCoursewareFolder () {
      Indicator.open()
      var _this = this;
      console.log(_this.hyCode);
      var params = { professionId:0 }
      getCoursewareFolder(params).then(res => {
        if (res.data.returnCode === 1) {
          this.isHasdata = false
          Indicator.close()
          _this.CoursewareList = res.data.returnDate
        } else {
          this.isHasdata = true
        }
      })
    },
    tovideolist (id) {
      this.$router.push({
        path: '/vList',
        query: { folderId: id, year: this.StudyMonth }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/videoGroup.vue